/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkflowJSONResponse } from './workflow-json-response';


export interface WorkflowDto { 
    /**
     * Subject ID
     */
    _id: string;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
    /**
     * Weather the workflow is active or not
     */
    active: boolean;
    /**
     * Weather the workflow is restricted or not
     */
    restricted: boolean;
    /**
     * Trigger mode
     */
    triggerType: WorkflowDto.TriggerTypeEnum;
    /**
     * Trigger value
     */
    triggerValue: string;
    /**
     * JSON response
     */
    jsonResponse: WorkflowJSONResponse;
    /**
     * Number of retries if fails
     */
    autoRetries: number;
    /**
     * Created at
     */
    createdAt: string;
    /**
     * Created by
     */
    createdBy: string;
    /**
     * Updated at
     */
    updatedAt: string;
    /**
     * Updated by
     */
    updatedBy: string;
    /**
     * Deleted at
     */
    deletedAt: string;
    /**
     * Deleted by
     */
    deletedBy: string;
}
export namespace WorkflowDto {
    export type TriggerTypeEnum = 'EVENT' | 'TIME' | 'WEBHOOK';
    export const TriggerTypeEnum = {
        Event: 'EVENT' as TriggerTypeEnum,
        Time: 'TIME' as TriggerTypeEnum,
        Webhook: 'WEBHOOK' as TriggerTypeEnum
    };
}


